import {ColumnDataType, Resource} from "../../shared/model/resource";

export const moduloResource: Resource = {
    nomeEntidade: {
        singular: 'Modulo',
        plural: 'Modulos'
    },
    fieldPk: 'uuid',
    route: {
        url: 'modulos',
    },
    colunas: [
        {
            field: 'posicao',
            required: true,
            type: ColumnDataType.Number,
            numberConfiguration: {
                minValue: 0
            },
            sizeColumn: 'col-12',
            unAvailableOnCreate: true
        },
        {
            field: 'nome',
            required: true,
            sizeColumn: 'col-12'
        },
        {
            field: 'descricao',
            label: 'Descrição',
            required: true,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
    ],
    actions: [],
    availableReferences: []
}
